import React from 'react';
import { useNavigate } from 'react-router-dom';
import DormRoomsHotspot from '../components/hotspots/DormRoomsHotspot';
import CampusDiningHotspot from '../components/hotspots/CampusDiningHotspot';
import MainCampusHotspot from '../components/hotspots/MainCampusHotspot';
import AthleticsHotspot from '../components/hotspots/AthleticsHotspot';
import ConferenceBallroomHotspot from '../components/hotspots/ConferenceBallroomHotspot';

function Home() {
  const navigate = useNavigate();

  return (
    <div className="page splash landingPage">
      <div className="home-map">
        <div className="dorm-rooms">
          <DormRoomsHotspot onClick={() => navigate('/dorm-rooms')} />
        </div>
        <div className="campus-dining">
          <CampusDiningHotspot onClick={() => navigate('/campus-dining')} />
        </div>
        <div className="main-campus">
          <MainCampusHotspot onClick={() => navigate('/main-campus')} />
        </div>
        <div className="athletics">
          <AthleticsHotspot onClick={() => navigate('/athletics')} />
        </div>
        <div className="conference-ballroom">
          <ConferenceBallroomHotspot onClick={() => navigate('/conference-and-ballroom')} />
        </div>
      </div>

      <div className="logo" onClick={() => navigate('/aboutus')}>
        <img src="/assets/higher-ed/Agilysys-Logo.svg" alt="Agilysys" className="logo" />
      </div>

      <div className="top-left">
        <div className="topic-header">
          Maximize Return on Experience
          <span className="sub-topic-header">For <strong>Higher Education</strong></span>
        </div>
        <div className="column">
          <div className="row"><span>Delight</span> students and faculty</div>
          <div className="row"><span>Retain</span> staff</div>
          <div className="row"><span>Grow</span> margins</div>
          <div className="line">
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="144" viewBox="0 0 8 144" fill="none">
              <path d="M4 4L4 140" stroke="#84BD00" strokeWidth="7" strokeLinecap="round"/>
            </svg>
          </div>
        </div>
      </div>

      <div className="bottom-left">
        <img className="touch-prompt" src="/assets/higher-ed/solutions/Blue-Touch-Icon.gif" alt="" />
        <div className="block">
          Explore our interactive{'\n'}
          Higher Education map to discover where{'\n'}
          <span>personal</span> meets <span>profitable</span>{'\n'}
          <strong>Touch an area to begin!</strong>
        </div>
      </div>
    </div>
  );
}

export default Home;
